import { Set } from 'immutable';

export class BehaviorService {
  private readonly StorageName = 'sentiments.bhvr.mem';
  private behaviors = Set<string>();

  constructor() {
    const data = window.sessionStorage.getItem(this.StorageName);
    const parsedData = this.parseData(data);
    this.behaviors = Set(parsedData);
    // If there are corrupted values we are replacing them now.
    this.saveToSession(this.behaviors);
  }

  private parseData(data: string | undefined): string[] {
    if (data && data != '') {
      try {
        return JSON.parse(data);
      } catch (err) {
        return [];
      }
    }
    return [];
  }

  private saveToSession(data: Set<string>): void {
    window.sessionStorage.setItem(this.StorageName, JSON.stringify(data.toJSON()));
  }

  /**
   * Add new service to memory
   * @param service
   */
  newService(service: string) {
    this.behaviors = this.behaviors.add(service);
    this.saveToSession(this.behaviors);
  }

  /**
   * List out if the given service is already has submitted a rating
   * @param service
   */
  isServiceCompleted(service: string): boolean {
    return this.behaviors.has(service);
  }
}
